import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { fetchStatsByType } from 'Store/stats/actions';
import { initializeList, updateStatsListSearch } from 'Store/lists/actions';
import * as reducers from 'Store/reducers';
import ConnectedFormattedMessage from 'Containers/ConnectedFormattedMessage';

import Error from 'Containers/Error';
import Loading from 'Components/Loading';
import { getDateString, daysUntilDate } from '../../utilities';
import { getPlanByLicense } from '../../settings/pricing-options';
import Table from 'Components/Table';
import { ROUTES } from '../../settings/route-strings';

class AdminStatsPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isRefreshing: false };
  }

  componentDidMount() {
    this.fetchStats();
  }

  // componentDidUpdate() {
  //   if (this.props.schoolStats && !this.state.loggedSchoolStats)
  //     this.setState({ loggedSchoolStats: true, requestedStats: false }, () =>
  //       console.log(JSON.stringify(this.props.schoolStats, null, 2))
  //     );
  // }

  fetchStats() {
    this.setState({ isRefreshing: true });
    this.props.initializeList('schools_stats', 'schools_stats');
    this.props.fetchStatsByType('schools').then(() => {
      this.setState({ isRefreshing: false });
    });
  }

  render() {
    const { activeUser, pageError, list, schoolStats } = this.props;
    const { isRefreshing } = this.state;
    if (pageError) return <Error type="apiLoadError" code="500" />;
    if (!activeUser || !list || !schoolStats) return <Loading />;

    const { data } = list;
    const Header = ({ column: { id } }) => (
      <ConnectedFormattedMessage id={`users_list.column_labels.${id}`} />
    );

    const columns = [
      { Header: 'ID', accessor: 'school_id', width: 80 },
      { Header, accessor: 'school_name' },
      {
        Header,
        accessor: 'license_type',
        Cell: ({ value }) => {
          const plan = getPlanByLicense(value);
          if (!plan) return '';
          return `${plan.type}${plan.licenseTerm === 'trial' ? ' trial' : ''}`;
        },
      },
      { Header, accessor: 'admin_email' },
      {
        Header,
        accessor: 'admin_last_login',
        Cell: ({ value }) =>
          value &&
          getDateString(new Date(value), {
            timeZone: 'America/New_York',
            day: 'numeric',
            month: 'numeric',
            year: '2-digit',
            hour: 'numeric',
          }),
      },
      { Header, accessor: 'total_logins', width: 70 },
      { Header, accessor: 'educator_count', width: 70 },
      { Header, accessor: 'student_count', width: 70 },
      {
        Header: 'Status',
        accessor: 'school_deactivated',
        Cell: ({ value }) => <span>{value ? 'Deactivated' : 'Active'}</span>,
      },
      {
        Header,
        accessor: 'license_end',
        width: 120,
        Cell: ({ value }) => value && daysUntilDate(new Date(value)),
      },
      {
        Header,
        accessor: 'admin_marketing_emails',
        Cell: ({ value }) => value && value.toString(),
      },
    ];

    const dataList = Object.keys(data).map((key) => data[key]);

    return (
      <div>
        <div style={{ height: '2em' }}>
          {isRefreshing ? (
            <span>Loading...</span>
          ) : (
            <button type="button" onClick={() => this.fetchStats()}>
              Refresh
            </button>
          )}
        </div>
        <Table
          columns={columns}
          data={dataList}
          getTrProps={(_, { original } = {}) => {
            const { school_deactivated } = original || {};
            const isDeactivated = !!school_deactivated;
            return {
              style: {
                opacity: isDeactivated && '0.5',
              },
            };
          }}
        />
      </div>
    );
  }
}

AdminStatsPage.propTypes = {
  activeUser: PropTypes.object,
  pageError: PropTypes.object,
  list: PropTypes.object,
  schoolStats: PropTypes.object,
  initializeList: PropTypes.func.isRequired,
  fetchStatsByType: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const type = 'schools';
  return {
    activeUser: reducers.getActiveUser(state),
    pageError: reducers.getPageError(state, ROUTES.ADMIN_V2_STATS_SCHOOLS),
    isFetchingStats: reducers.isFetchingStats(state, 'statsByType'),
    list: reducers.getStatsListByType(state, type),
    schoolStats: reducers.getSchoolStatsBreakdown(state),
  };
};

export default connect(mapStateToProps, {
  fetchStatsByType,
  initializeList,
  updateStatsListSearch,
})(AdminStatsPage);
